import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import WhyVisit from "@/components/WhyVisit";
import Collections from "@/components/Collections";
import VisitorExperience from "@/components/VisitorExperience";
import GeorgeTown from "@/components/GeorgeTown";
import VisitUs from "@/components/VisitUs";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="bg-heritage-ink font-sans antialiased">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <About />
                <WhyVisit />
                <Collections />
                <VisitorExperience />
                <GeorgeTown />
                <VisitUs />
                <Faq />
                <FinalCta />
            </main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}

export default App;
